import { useState, useEffect } from "react";
import { Badge, Form, Offcanvas, Spinner } from "react-bootstrap";
import { studySubjectScreenFailedReasonServices } from "../../../../APIServices/CTMS/SubjectManagement/studySubjectScreenFailedReasonServices";
import { useParams } from "react-router";

const ScreeningFail = ({
  Show,
  Hide,
  Title,
  subjectUpdateLoader,
  updateStudySubjectScreen,
  reason,
  setReason
}) => {
  const [reasonType, setReasonType] = useState("dynamic");
  const [reasonList, setReasonList] = useState([]);
  const { studyId } = useParams()

  const getStudySubjectScreenFailedReasonData = async () => {
    let data = await studySubjectScreenFailedReasonServices.getStudySubjectScreenFailedReasonData("active", studyId)
    setReasonList(data?.data || [])
  }

  useEffect(() => {
    getStudySubjectScreenFailedReasonData()
  }, []);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-1">
          <div className="hstack gap-2">
            <Form.Label className="fw-bold mb-1">
              Reason{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Badge onClick={() => { setReasonType(reasonType === "dynamic" ? "custom" : "dynamic"); setReason("") }} bg="primary" className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>{reasonType === "dynamic" ? "custom" : "dynamic"}</Badge>
          </div>
          {reasonType === "dynamic" ?
            <Form.Select
              onChange={(e) => setReason(e.target.value)}
              style={{ fontSize: 12 }}
              className="br3"
              value={reason}
            >
              <option value="">Select Reason</option>
              {reasonList?.map((item => (
                <option value={item?.reason}>
                  {item?.reason}
                </option>
              )))}
            </Form.Select>
            :
            <Form.Control
              className="br3"
              onChange={(e) => setReason(e.target.value)}
              rows={3}
              value={reason}
              placeholder="Enter Reason"
              as="textarea"
            />
          }
        </Form.Group>
      </Offcanvas.Body>
      <div className="p-2 border-top bg-light text-end">
        <button
          disabled={!reason || subjectUpdateLoader}
          className="updateProfile"
          onClick={updateStudySubjectScreen}
        >
          {subjectUpdateLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Failing...
            </div>
          ) : (
            "Mark Screening Fail"
          )}

        </button>
      </div>
    </Offcanvas>
  );
};

export default ScreeningFail;
